import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { mutate } from 'swr';
import { useSocket } from '../../containers/websocket-provider.tsx';

export function WebSocketBankAccountWatcher() {
  const { getLatest } = useSocket();
  const dispatch = useDispatch();
  const changed = getLatest('bank_account_changed');

  const lastEventKeyRef = useRef<string | number | null>(null);

  useEffect(() => {
    if (changed) {
      // @ts-ignore
      const eventKey = `${changed.action}:${changed.data?.player_id ?? 'unknown'}`;

      if (lastEventKeyRef.current === eventKey) return;
      lastEventKeyRef.current = eventKey;
      // @ts-ignore
      mutate('/restapi/v1/withdrawals');
    }
  }, [dispatch, changed]);

  return null;
}
